import styled from "styled-components";

export const Wrapper = styled.main`
  max-width: 900px;
  min-width: 200px;
  margin: 0 auto;
  padding: 20px;
`;
